import { render, staticRenderFns } from "./daily-challenge.vue?vue&type=template&id=f790323e&"
import script from "./daily-challenge.vue?vue&type=script&lang=js&"
export * from "./daily-challenge.vue?vue&type=script&lang=js&"
import style0 from "./daily-challenge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox, CImage: require('@chakra-ui/vue').CImage, CFlex: require('@chakra-ui/vue').CFlex, CButton: require('@chakra-ui/vue').CButton})
